<ui-section
	[collapsable]="true"
	[collapsed]="shouldCollapseSignal()"
	[title]="sectionTitle"
	(onCollapsedChange)="onCollapsedChange($event)"
	[titleImg]="titleImgConfig_()"
	[testHook]="testHooks.TitleSection"
>
	<div section-content>
		<div class="grid grid-cols-2 gap-12">
			<div class="flex flex-col gap-6 h-fit">
				<div class="flex flex-col gap-4">
					<h4 class="text-lg font-medium text-gray-950 m-0">Provider</h4>

					<div class="flex flex-row items-center">
						<p class="text-gray-700 text-base mr-2">
							{{ providerName() }}
						</p>
						<ui-button
							size="sm"
							[style]="'ghost'"
							[label]="buttonState()"
							(click)="openModal()"
							[testHook]="testHooks.SignItButton"
						></ui-button>
					</div>
				</div>

				<div class="flex flex-col gap-4" *ngIf="showFinancialSettings_()">
					<h4 class="text-lg font-medium text-gray-950 m-0">Fee Placement</h4>

					<app-direction-of-fee-dropdown
						[currentDirectionOfFee]="defaultESigningSettings_()?.location"
						label="Display Line Item(s) In"
						fieldToUpdate="{{ firestoreDefaultSettingsPath }}.location"
						intercomAttr="sign-it-display-amount-setting"
					/>

					@if (showFeeAndHstSettings_()) {
						<app-input
							type="cents"
							[ngModel]="defaultESigningSettings_()?.amount"
							(debounce)="setAmount($event)"
							label="Fee Amount (Per Sent Signing Package)"
							[testHook]="testHooks.FeeAmountInput"
						/>

						<ui-note title="Note" [testHook]="testHooks.Note">
							<p>
								Changes will only apply to new matters to avoid impacts to
								existing records
							</p>
						</ui-note>
					}
				</div>
			</div>

			<div class="flex flex-col gap-6 h-fit">
				@if (showFinancialSettings_() && showFeeAndHstSettings_()) {
					<div class="flex flex-col gap-4">
						<h4 class="text-lg font-medium text-gray-950 m-0">
							Additional Settings
						</h4>

						<ui-checkbox
							label="Fee subject to HST"
							[ngModel]="defaultESigningSettings_()?.hst"
							(ngModelChange)="setHst($event)"
							data-intercom-target="sign-it-fee-amount-setting"
							[testHook]="testHooks.FeeSubjectToHstCheckbox"
						/>
					</div>
				}
				<div class="flex flex-col gap-2 mt-4">
					<h5 class="font-medium h5">Edit Default Note</h5>
					<p class="p-sm">
						This note will appear in the email your recipients receive.
					</p>
				</div>
				<app-text-area
					name="defaultNote"
					(debounce)="onNoteDebounced($event)"
					[(ngModel)]="notes"
					[rows]="4"
				></app-text-area>
			</div>
		</div>
		@if (showSignItNote()) {
			<div class="mt-4">
				<ui-alert
					[type]="ALERT_TYPES.INFO"
					callToActionType="CLOSE"
					[omitCloseLogic]="true"
					(callToActionClick)="hideSignItNote()"
					[testHook]="testHooks.SignItNote"
				>
					<div class="flex flex-1 flex-row items-center justify-between gap-4">
						<div class="flex flex-row items-center gap-2">
							<img
								src="assets/images/integrations/sign-it/sign-it-logo.svg"
								alt="SignIT Logo"
								class="w-9"
							/>
							<p class="text-base">
								Connect to SignIT to prepare and send docs for E-signing in
								Closer!
							</p>
						</div>
						<div>
							<a
								class="text-sm text-green-600 cursor-pointer hover:underline"
								(click)="signItNavigationUrl()"
								>Learn more</a
							>
						</div>
					</div>
				</ui-alert>
			</div>
		}
	</div>
</ui-section>
